import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useProductCoddingDelete = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteLoading, setDeleteLoading] = useState(false);
  const deleteRequest = (guid, onSuccess) => {
    setDeleteLoading(true);
    axiosClient
      .delete(`Product/Branch/Codding/Delete?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          onSuccess?.();
          enqueueSnackbar(`حذف با موفقیت انجام شد`, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setDeleteLoading(false));
  };
  return { deleteRequest, deleteLoading };
};

export default useProductCoddingDelete;
